// packages imports
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

// components imports
import { Divider, Grid, Typography } from '@mui/material'
import CheckboxController from '../../../common/CheckboxController'

// other imports
import { Assignee } from '../../../../interfaceTypes'
import { UserRole, UserType } from '../../../../../generated'
import UserDropdownWithForm from '../../../common/UserDropDownWithForm'

interface BillApproverListFormProps {
  isEdit: boolean
}

const BillApproverListForm = ({ isEdit }: BillApproverListFormProps) => {
  const { getValues, setValue } = useFormContext()

  useEffect(() => {
    const legalTeam: Assignee[] = getValues('legalTeam')
    const billApproverId = getValues('billing.billApproverId')
    const skipDeptHeadApproval = getValues('billing.skipDeptHeadApproval')

    if (!isEdit) {
      if (!billApproverId) {
        const billingAttorneyId = legalTeam?.find(user => user.userType === UserType.ResponsibleAttorney_1)?.userId
        setValue('billing.billApproverId', billingAttorneyId)
      }
      if (skipDeptHeadApproval === undefined) {
        setValue('billing.skipDeptHeadApproval', true)
      }
    }
    // eslint-disable-next-line
  }, [])

  return (
    <Grid container item rowSpacing={2.5}>
      <Grid item xs={12}>
        <Divider />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="body1" textTransform="uppercase" fontWeight={700}>
          Bill Approver
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <UserDropdownWithForm
          name="billing.billApproverId"
          label="Approver of Final Bill"
          roles={[UserRole.Attorney]}
          disableClearable
        />
      </Grid>

      <Grid item xs={12}>
        <CheckboxController
          name="billing.skipDeptHeadApproval"
          label="Skip Department Head's Approval"
          sx={{ mt: -1 }}
        />
      </Grid>
    </Grid>
  )
}

export default BillApproverListForm
